<script setup>
import { computed } from 'vue';
import { CORES_STATUS_CONVITE, ICONES_STATUS_CONVITE } from '@/commons/convites';

const props = defineProps({
    valor: String,
});

const cor = computed(() => CORES_STATUS_CONVITE[props.valor] ?? 'cinza');
const icone = computed(() => ICONES_STATUS_CONVITE[props.valor]);
</script>

<template>
    <TagBase :valor="valor" :cor="cor" :icone="icone" />
</template>
